<template>
    <tr class="mds-data-table__row">
        <TableDataCell 
            v-for="(dataCell, index) in row"
            :key="index"
            :dataCell="dataCell"
            :isScoped="isScoped(dataCell)"
        />
    </tr>
</template>

<script>
import TableDataCell from "./TableDataCell";

export default {
    props: {
        row: {
            type: Array,
            required: true
        }
    },
    components: {
        TableDataCell
    },
    methods: {
        isScoped (dataCell) {
            return dataCell.scoped;
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/TableRow.vue